import type { ComputedRef } from 'vue'
import type { AppBadgeColor } from '../../app-badge'
import type { BadgeSlotStatusProps } from '../types/interfaces'

import { TutorSlotStatus } from '@brighterly/lib-core-types/tutor/enums'

import { useListsStore } from '@shared/model'

import { useBadgeFromStatus } from '../../app-badge'

interface BadgeSlotStatusOptions {
  props: BadgeSlotStatusProps
}

interface BadgeSlotStatusReturn {
  color: ComputedRef<AppBadgeColor>
  text: ComputedRef<string>
}

const STATUS_COLORS: Partial<Record<TutorSlotStatus, AppBadgeColor>> = {
  [TutorSlotStatus.Registered]: 'slate',
  [TutorSlotStatus.Completed]: 'emerald',
  [TutorSlotStatus.Canceled]: 'red',
  [TutorSlotStatus.Generated]: 'slate',
  [TutorSlotStatus.Scheduled]: 'slate',
  [TutorSlotStatus.Confirmed]: 'blue',
  [TutorSlotStatus.CheckedIn]: 'indigo',
  [TutorSlotStatus.LessonInProgress]: 'amber',
  [TutorSlotStatus.LessonCompleted]: 'emerald',
  [TutorSlotStatus.LessonCanceled]: 'red',
  [TutorSlotStatus.TutorNoShow]: 'red',
  [TutorSlotStatus.NoBooking]: 'orange',
}

export const useBadgeSlotStatus = ({ props }: BadgeSlotStatusOptions): BadgeSlotStatusReturn => {
  const listsStore = useListsStore()

  return useBadgeFromStatus<TutorSlotStatus>({
    status: () => props.status,
    colors: STATUS_COLORS,
    labels: () => listsStore.getTutorSlot?.status,
  })
}
